import NotamAIItem from '../airport/notam-item';
import classNames from 'classnames';
import {useEffect, useState} from 'react';

const NotamLayer = () => {
  const [showData, setShowData] = useState<any>(false);
  useEffect(() => {
    setTimeout(() => {
      if (!window?.map?.on) return;
      window.map.on('click', ['notam-symbol', 'notam-fir-symbol'], (e: any) => {
        console.log(e?.features?.[0]?.properties);
        if (e?.features?.[0]?.properties?.airport) {
          setShowData(e?.features?.[0]?.properties);
        }
      });
    }, 3000);
  }, []);

  if (!showData) return <></>;
  return (
    <>
      <div onClick={() => setShowData(false)}>
        <div className={classNames('absolute bottom-0 left-0 right-0 top-0')} />
      </div>
      <div
        className={classNames(
          'notam-layer absolute bottom-[85px] right-0 w-[500px] bg-[#ffffff]/10 rounded-lg p-2 left-0 mx-auto backdrop-blur-md items-center'
        )}
      >
        <NotamAIItem
          index={0}
          item={showData}
          airport={showData?.airport}
          hasBorder={false}
        />
      </div>
    </>
  );
};

export default NotamLayer;
